import { useMutation } from '@tanstack/react-query';
import { IEmbedV3 } from '@opengov/reporting-types';
import { save as saveEmbedSDK } from '@opengov/reporting-embeds';

import { useToast } from '../../../../stories/components/Toast/context/useToast.context';
import { embedPickerQueryKeys } from './embedPickerQueryKeys';

export type CreateV3EmbedVariables = {
  id?: string;
  title: string;
  description: string;
  reportId: string;
  savedViewId: string;
  shouldSync: boolean;
  reportVersion: string;
  type: string;
  data?: any;
  controller?: AbortController;
};

export function useCreateV3Embed() {
  const { toggleToast } = useToast();

  return useMutation<IEmbedV3, Error, CreateV3EmbedVariables>({
    mutationKey: [...embedPickerQueryKeys.all, 'createV3Embed'],
    mutationFn: async ({ controller, ...payload }) => {
      const result = await saveEmbedSDK({ ...payload, version: 'v3' }, controller);
      if (!result?.id) {
        throw new Error('Could not create embed');
      }
      return result as IEmbedV3;
    },
    onError: () => {
      toggleToast({ title: 'Could not create embed', severity: 'error' });
    }
  });
}
